import {
  CheckExitFeedBackFormTypes,
  IncomingEmployeeSeparationForm,
  SeparationDownloadFileProps,
} from '../../../../types/MyProfile/Separation/separationTypes'
import {
  getAuthenticatedRequestConfig,
  useAxios,
} from '../../../../utils/apiUtils'
import { AllowedHttpMethods, MyProfileSeparationApiConfig } from '../../apiList'

const getEmployeeSeparationForm = async (
  employeeId: number,
): Promise<IncomingEmployeeSeparationForm> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: MyProfileSeparationApiConfig.getEmployeeSeparationForm,
    method: AllowedHttpMethods.get,
    params: {
      employeeId,
    },
  })
  const response = await useAxios(requestConfig)
  return response.data
}

const separationDownloadForm = async (
  props: SeparationDownloadFileProps,
): Promise<Blob | undefined> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: MyProfileSeparationApiConfig.separationDownloadForm,
    method: AllowedHttpMethods.get,
    params: {
      fileName: props.fileName ?? '',
      token: localStorage.getItem('token') ?? '',
      tenantKey: localStorage.getItem('tenantKey') ?? '',
    },
    responseType: 'blob',
  })
  const response = await useAxios(requestConfig)
  return response.data
}
const separationDownloadFile = async (
  props: SeparationDownloadFileProps,
): Promise<Blob | undefined> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: MyProfileSeparationApiConfig.separationDownloadFile,
    method: AllowedHttpMethods.get,
    params: {
      fileName: props.fileName ?? '',
      token: localStorage.getItem('token') ?? '',
      tenantKey: localStorage.getItem('tenantKey') ?? '',
    },
    responseType: 'blob',
  })
  const response = await useAxios(requestConfig)
  return response.data
}

const checkExitFeedBackForm = async (
  separationId: number,
): Promise<CheckExitFeedBackFormTypes> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: MyProfileSeparationApiConfig.checkExitFeedBackForm,
    method: AllowedHttpMethods.get,
    params: {
      separationId,
    },
  })
  const response = await useAxios(requestConfig)
  return response.data
}

const SeparationApi = {
  getEmployeeSeparationForm,
  separationDownloadForm,
  separationDownloadFile,
  checkExitFeedBackForm,
}

export default SeparationApi
